<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle">ACKNOWLEDGMENTS</h2>
<h4 class="section1"><i>I offer my sincerest thanks:</i></h4>
<p class="indent_top">To my cousin and friend Brent Bingham who taught me how to rock climb.</p>
<p class="indent">To Dean Blanchard of Wharton, who gave me a chance to prove I could do the work and be employable, and the Wharton School for making an investment in me that paid off for us both.</p>
<p class="indent">To my brother David, my first best friend whom I miss to this day.</p>
<p class="indent">To the many family and friends who did not let me give up on myself</p>
<p class="indent">To Dr. Fernando Flores, who taught me how to think.</p>
<p class="indent">To my Uncle Jake Garn, United States Senator and space shuttle astronaut who visited me in the hospital for forty-two days straight.</p>
<p class="indent">To George Gilder, who taught me to listen to technology and how it changes the economy by changing the relative prices of factors of production.</p>
<p class="indent">To all the neighbors that day in Salt Lake City who rushed to my aid, especially Ruth Johnson, the nurse who saved my life.</p>
<p class="indent">To Dr. Art Laffer, who taught me serious economics.</p>
<p class="indent">To Dr. Drew Lebby, my dear friend and trusted advisor for over thirty-five years.</p>
<p class="indent">To James McClennen, who gave me the chance to prove I could learn to invest.</p>
<p class="indent">To my fraternity brother Kendall Oldroyd who encouraged me during graduate school during what appeared to be a futile job search, with his words, “if you were a stock, I would invest in you.”</p>
<p class="indent">To Stanford and Harvard for rejecting my graduate school applications. They joined the extensive list who said, “You can’t.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?ac9a4728